// Entry point: mount the Diatom Synth app.
import { App } from './app/App';

const root = document.getElementById('app');
if (root) {
  const app = new App(root);
  app.mount();
}
